const termsConditions = {
  title: 'Terms & Conditions',
  lastUpdated: 'Last Updated: October 24, 2025',
  sections: [
    {
      heading: 'Introduction and Acceptance of Terms',
      paragraphs: [
        'These Terms and Conditions (“Terms”) govern your access to and use of the Mutawir Studios website and any services provided by Mutawir Studios (“Mutawir,” “we,” or “us”). By accessing our Site or engaging our services, you agree to be bound by these Terms. If you do not agree, you must refrain from using our Site or services. Continued use after updates constitutes acceptance of the revised Terms.'
      ]
    },
    {
      heading: 'Scope of Services and Separate Agreements',
      paragraphs: [
        'Mutawir Studios provides digital consultancy services, including web development, strategy, design, marketing, and related offerings. Specific scopes, deliverables, timelines, and fees are defined in separate written agreements or statements of work. These Terms form a general framework; if they conflict with a specific agreement, the latter prevails for that engagement. Site content is provided for informational purposes and may not reflect the most current developments.'
      ]
    },
    {
      heading: 'Client Responsibilities and Obligations',
      paragraphs: [
        'Clients agree to provide accurate information, use the Site and services lawfully, maintain confidentiality of non-public information, cooperate with Mutawir, use deliverables as intended, and comply with third-party terms when applicable. Failure to meet these responsibilities may result in suspension or termination of access and may limit Mutawir’s obligations.'
      ]
    },
    {
      heading: 'Engagement of Services and Deliverables',
      paragraphs: [
        'Service performance details are typically outlined in a separate agreement. Mutawir delivers services in a professional manner and works to meet agreed schedules, subject to scope changes or delays outside our control. Change requests require written agreement on scope, timeline, and fees. Clients must review deliverables promptly; acceptance may be assumed after a reasonable review period or upon live use. Clients affirm they have rights to any materials they supply and that Mutawir may use them solely for the engagement.'
      ]
    },
    {
      heading: 'Intellectual Property Rights',
      paragraphs: [
        'Mutawir retains ownership of its intellectual property, methodologies, templates, and know-how (“Mutawir IP”). Upon full payment, clients receive appropriate rights to use deliverables for agreed business purposes. Certain custom deliverables may be assigned if specified in writing, while Mutawir retains general know-how and pre-existing materials. Mutawir may reference non-confidential aspects of projects in portfolios unless otherwise agreed. Clients retain ownership of materials they provide and grant Mutawir a limited license to use them during the project.'
      ]
    },
    {
      heading: 'Confidentiality',
      paragraphs: [
        'Both parties may share confidential information during an engagement and agree to protect it using at least reasonable care, limiting access to those with a need to know, and using it only for the intended purpose. Confidentiality obligations do not apply to information that is public, previously known without obligation, obtained lawfully from a third party, independently developed, or disclosed pursuant to legal requirements. Obligations survive termination.'
      ]
    },
    {
      heading: 'Disclaimers of Warranties',
      paragraphs: [
        'Except as expressly stated in a written agreement, Mutawir provides all services, deliverables, and site content “as is” without warranties of any kind, including implied warranties of merchantability, fitness for a particular purpose, title, or non-infringement. We do not guarantee specific business results, uninterrupted operation, or accuracy of information, and we are not responsible for third-party tools or services beyond our control.'
      ]
    },
    {
      heading: 'Limitation of Liability',
      paragraphs: [
        'To the maximum extent permitted by law, Mutawir is not liable for indirect, incidental, consequential, special, punitive, or exemplary damages, including loss of profits, revenue, data, or business opportunities. Total cumulative liability is capped at fees paid for the specific service giving rise to the claim (or US $100 for purely website use). Clients are responsible for consequences arising from their own misuse, false information, or third-party claims tied to materials they provide. Mutawir is not liable for delays caused by force majeure events. Mandatory legal obligations that cannot be limited remain unaffected.'
      ]
    },
    {
      heading: 'Minors and Eligibility',
      paragraphs: [
        'Our Site and services target adults and business entities. Individuals under 18 may not engage Mutawir without involvement of a parent, guardian, or authorized representative. We reserve the right to refuse engagements lacking proper authorization.'
      ]
    },
    {
      heading: 'Termination',
      paragraphs: [
        'We may suspend or terminate access to the Site at any time. Service engagements may be terminated as outlined in the specific agreement, typically for cause after notice and an opportunity to cure, or for convenience where permitted, with appropriate settlement of fees for work performed. Upon termination, clients must cease using unpaid deliverables and respect intellectual property and confidentiality obligations, which survive termination.'
      ]
    },
    {
      heading: 'Changes to These Terms',
      paragraphs: [
        'Mutawir may update these Terms to reflect changes in practices, services, or legal requirements. We will update the “Last Updated” date and post revisions on the Site, providing additional notice for significant changes. Continued use after updates constitutes acceptance. Clients should review the Terms periodically.'
      ]
    },
    {
      heading: 'Governing Law and Dispute Resolution',
      paragraphs: [
        'These Terms are governed by the laws of the Lebanese Republic. Disputes should first be addressed through good-faith negotiations, and if unresolved, submitted to the exclusive jurisdiction of the courts of Beirut, Lebanon. Mutawir may seek injunctive relief in other jurisdictions to protect intellectual property or confidential information. International clients agree to the specified jurisdiction.'
      ]
    },
    {
      heading: 'Miscellaneous Provisions',
      paragraphs: [
        'Failure to enforce any provision is not a waiver of future enforcement. If any provision is deemed invalid or unenforceable, the remainder remains in effect. These Terms, together with any applicable service agreement, constitute the entire agreement. Clients may not assign obligations without Mutawir’s consent; Mutawir may assign in connection with corporate transactions. The relationship is that of independent contractor unless otherwise specified.'
      ]
    },
    {
      heading: 'Contact Information',
      paragraphs: [
        'For questions about these Terms or to provide notices, contact Mutawir Studios at info@mutawirstudios.com or at our Beirut, Lebanon office. We will respond promptly to address your concerns.'
      ]
    }
  ]
};

export default termsConditions;
